import React from 'react';
import { Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';
export default function BaseButton({
  onClick,
  children,
  w100,
  disabled,
  outline,
  loading,
  disabledStyle,
}) {
  let className = 'btn';

  if (w100) {
    className += ' w-100';
  }

  if (outline) {
    className += ' outline';
  }

  if (disabled) {
    className += ' disabled';
  }
  if (disabledStyle) {
    className += ' disabled-fake';
  }
  return (
    <button onClick={onClick} disabled={disabled} className={className}>
      {!loading && children}
      {loading && (
        <div className="bootstrap">
          <Spinner animation="border" />
        </div>
      )}
    </button>
  );
}

BaseButton.defaultProps = {
  onClick: () => {},
  w100: true,
  disabled: false,
  outline: false,
  loading: false,
  disabledStyle: false,
};

BaseButton.propTypes = {
  onClick: PropTypes.func,
  w100: PropTypes.bool,
  disabled: PropTypes.bool,
  outline: PropTypes.bool,
  loading: PropTypes.bool,
  disabledStyle: PropTypes.bool,
};
